module.exports = __webpack_public_path__ + "img/company-2.8a021e2b.jpg";